import React from "react";

import AddressSetter from "components/Form/AddressSetter";
import FormInputNumber from "components/Form/Input/Number";
import FormInputSelect from "components/Form/Input/Select";
import FormTitle from "components/Form/Title";
import FormErrors from "pages/ApplicationForm/components/FormErrors";
import { StepProps } from "../../types";
import { LABELS } from "./labels";
import { PropertyStyles, PropertyTypes } from "./options";
import FormInputRadio from "components/Form/Input/Radio";
import { checkFalseyValue } from "utils/validation";
import { useWatch } from "react-hook-form";

const STEP_KEY = "property";

const PropertyForm: React.FC<StepProps> = ({
  control,
  clearErrors,
  setValue,
  register,
  errors,
}) => {
  const isSecuredPropertySameAsApplicantAddress = useWatch({
    name: `${STEP_KEY}.isSecuredPropertySameAsApplicantAddress`,
    control: control,
  });

  return (
    <div className="flex flex-col space-y-4">
      <FormTitle left border title="Property" mb={false} />

      <FormErrors formErrors={errors?.[STEP_KEY]} />

      <FormInputRadio
        id={`${STEP_KEY}.isSecuredPropertySameAsApplicantAddress`}
        label={LABELS.isSecuredPropertySameAsApplicantAddress}
        register={register}
        initValue={isSecuredPropertySameAsApplicantAddress}
        error={
          errors?.[STEP_KEY]?.isSecuredPropertySameAsApplicantAddress?.message
        }
      />

      {checkFalseyValue(isSecuredPropertySameAsApplicantAddress) && (
        <div className="flex flex-col space-y-4">
          <label className="block text-base">
            Full address of the property
          </label>

          <AddressSetter
            clearErrors={clearErrors}
            setValue={setValue}
            register={register}
            idKey={STEP_KEY}
            errorKey={errors?.[STEP_KEY]}
          />
        </div>
      )}

      <FormInputSelect
        id={`${STEP_KEY}.propertyType`}
        label={LABELS.propertyType}
        register={register}
        initSelect
        options={PropertyTypes}
        requiredField={false}
        error={errors?.[STEP_KEY]?.propertyType?.message}
      />

      <FormInputSelect
        id={`${STEP_KEY}.propertyStyle`}
        label={LABELS.propertyStyle}
        register={register}
        initSelect
        options={PropertyStyles}
        requiredField={false}
        error={errors?.[STEP_KEY]?.propertyStyle?.message}
      />

      <FormInputNumber
        id={`${STEP_KEY}.noOfBedrooms`}
        label={LABELS.noOfBedrooms}
        register={register}
        error={errors?.[STEP_KEY]?.noOfBedrooms?.message}
      />
    </div>
  );
};

export default PropertyForm;
